'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('./../../external/classnames/index.js');
var BreadCrumbs = require('../BreadCrumbs/BreadCrumbs.js');
var PropTypes = require('prop-types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var PageHeader = function PageHeader(_ref) {
  var children = _ref.children,
    location = _ref.location,
    homeName = _ref.homeName;
  var pageHeaderClasses = index.default('pageheader');
  return /*#__PURE__*/React__default.default.createElement("div", {
    className: pageHeaderClasses,
    "data-testid": "lanl-pageheader"
  }, /*#__PURE__*/React__default.default.createElement(BreadCrumbs.BreadCrumbs, {
    homeName: homeName,
    location: location,
    className: "pageheader-breadcrumbs"
  }), children);
};
PageHeader.defaultProps = {};
PageHeader.propTypes = {
  children: PropTypes__default.default.node,
  homeName: PropTypes__default.default.string,
  location: PropTypes__default.default.object
};

exports.PageHeader = PageHeader;
exports.default = PageHeader;
//# sourceMappingURL=PageHeader.js.map
